import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { formatDate } from 'bookingform';

import CalendarIcon from '../icons/CalendarIcon';

class BookingFormDates extends React.Component {
  formatDate(date) {
    const { lang, chain } = this.props;
    return formatDate(date, lang, chain);
  }

  getNights() {
    const init = moment(this.props.checkIn);
    const end = moment(this.props.checkOut);
    return end.diff(init, 'days');
  }

  render() {
    const { checkIn, checkOut } = this.props;
    return (
      <div className="BookingFormDates">
        <CalendarIcon />
        <div className="header-title font-weight-bold">{this.context.t('Dates')}</div>
        <span className="info-text">
          {this.formatDate(checkIn)} -
          {this.formatDate(checkOut)}
        </span>
        <span className="light">
          &nbsp;&nbsp;({this.context.t(['{n} night', '{n} nights', 'n'], { n: this.getNights() })})
        </span>
      </div>
    );
  }
}

BookingFormDates.propTypes = {
  checkIn: PropTypes.string,
  checkOut: PropTypes.string,
  lang: PropTypes.string,
  chain: PropTypes.string,
};

BookingFormDates.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default BookingFormDates;
